export const selectArticlesLength = (state) =>
  state.dashboard.articlesLength || 0;
export const selectIsLoading = (state) => state.dashboard.isLoading;
export const selectPresentationsLength = (state) =>
  state.dashboard.presentationsLength || 0;
export const selectGroupsLength = (state) => state.dashboard.groupsLength || 0;
